import { render, staticRenderFns } from "./shipmentStaffList.vue?vue&type=template&id=673371da"
import script from "./shipmentStaffList.vue?vue&type=script&lang=js"
export * from "./shipmentStaffList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports